__turbopack_context__.v({
  "hr": "PromoCode-module-scss-module__EeNYBq__hr",
  "promo-line": "PromoCode-module-scss-module__EeNYBq__promo-line",
  "promo-success": "PromoCode-module-scss-module__EeNYBq__promo-success",
  "terms-action": "PromoCode-module-scss-module__EeNYBq__terms-action",
});
